import React from 'react';
import { BrokerGuide, BrokerId } from '../../config/brokerImportGuides';

interface BrokerSelectorProps {
    brokerIds: BrokerId[];
    guides: Record<BrokerId, BrokerGuide>;
    selectedBrokerId: BrokerId;
    onSelect: (brokerId: BrokerId) => void;
}

export default function BrokerSelector({ brokerIds, guides, selectedBrokerId, onSelect }: BrokerSelectorProps) {
    return (
        <div className="grid grid-cols-2 md:grid-cols-3 gap-2 mb-6">
            {brokerIds.map((brokerId) => {
                const broker = guides[brokerId];
                return (
                    <button
                        key={broker.id}
                        onClick={() => onSelect(broker.id)}
                        className={`rounded-lg px-3 py-2 text-left text-sm border transition-colors ${
                            selectedBrokerId === broker.id
                                ? 'border-indigo-500/60 bg-indigo-500/10 text-indigo-100'
                                : 'border-white/10 text-slate-300 hover:border-indigo-400/50'
                        }`}
                    >
                        {broker.name}
                    </button>
                );
            })}
        </div>
    );
}
